import { Component } from '@angular/core';
import {BUILD_INFO} from "../../../../environments/build-info";

@Component({
    selector: 'app-footer',
    imports: [],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
    build = BUILD_INFO;
}
